import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'profile-group-option',
    templateUrl: './profile-group-option.component.html',
    styleUrls: ['./profile-group-option.component.scss'],
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileGroupOptionComponent extends UiComponent {
    @Input()
    label!: string;

    @Input()
    selected: boolean = false;

    @Input()
    minWidth?: string = '0px';
}
